import { serializer } from '@/api/shared/serializer';
import { StaffAccessLevels } from '@/enums/StaffAccessLevels';
import { batchUpdate } from '@/utils/batchUpdate';
import * as firebase from 'firebase/app';

export default {
  name: 'InviteUsersDialog',
  components: {},
  data() {
    return {
      dialog: false,
      loading: true,
      importing: false,
      accessLevels: Object.values(StaffAccessLevels),
      uninvitedUsers: [],
      headers: [
        {
          text: '',
          align: '',
          sortable: false,
          value: 'name',
        },
        {
          text: '',
          align: '',
          sortable: false,
          value: 'accessLevel',
        },
        {
          text: '',
          align: '',
          sortable: false,
          value: 'id',
        },
      ],
    };
  },
  computed: {
    anySelected() {
      return this.uninvitedUsers.some(x => x.import === true)
    },
  },
  methods: {
    async open(facilityId, orgId) {
      this.dialog = true;
      this.uninvitedUsers = serializer
        .querySnapshotToDocuments<any>(
          await firebase
            .firestore()
            .collection('users')
            .where('facilityId', '==', facilityId)
            .where('orgId', '==', orgId)
            .where('refOrigin', '==', 'rci')
            .get()
        )
        .filter(x => !x.invitationSent);
      this.loading = false;
    },
    close() {
      this.loading = false;
      this.importing = false;
      this.dialog = false;
    },
    async importUsers() {
      this.importing = true;

      const itemsToUpdate = this.uninvitedUsers
        .filter(x => x.import === true)
        .map(x => ({
          docId: x.id,
          updates: { accessLevel: x.accessLevel, invitationSent: true },
        }));

      console.log('itemsToUpdate: ', itemsToUpdate.length);

      await batchUpdate('users', itemsToUpdate)
        .then(() => {
          this.$toast.open({
            message: `Invitation has been sent to ${itemsToUpdate.length} user${
              itemsToUpdate.length > 1 ? 's' : ''
            }`,
            type: 'success'
          });
          this.close();
        })
        .catch(error => {
          this.close();
          this.$toast.open({
            message: error,
            type: 'Unhandled error',
          });
        });
    },
    selectAll(value){
        this.uninvitedUsers = this.uninvitedUsers.map(user => ({
            ...user,
            import: value
        }));
    }
  }
};
